import { render, staticRenderFns } from "./CardStat.vue?vue&type=template&id=34dbfbd6&"
import script from "./CardStat.vue?vue&type=script&lang=js&"
export * from "./CardStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports